import styled from 'styled-components'
import { Grid } from 'react-flexbox-grid'

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 0;
`

export const Container = styled(Grid)`
  max-width: 1200px;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/containers/App/style.js